import React from "react";
import { assetsInitialState, DealRoomEditState } from "src/types/dealRoom";
import { AssetsLayoutEnum, MenuState, ModuleEnum } from "../../types";
import { initialAssetsState } from "src/redux/reducers/dealRoomsReducer";

export interface ShareRecipient{
  firstName: string,
  lastName: string,
  company: string,
  email: string,
  sharedDate: number,
}
export interface DealRoomContextProps {
  id: string | null | undefined,
  dealRoom: DealRoomEditState,
  dealRoomAssets: assetsInitialState,
  activeModule: string | null,
  entityType: string;
  menuState: MenuState,
  onMenuChange : (menuState : any) => void,
  isDealRoomLoading: boolean,
  updateDealRoomProperty: (property: string, value: any) => void;
  getNotificationContent: () => {subject: string, message: string}
  getRecipient: (recipient) => ShareRecipient | null;
  fetchRecipientsForPage: (page) => void;
  itemSelector: string;
  editSelector: string;
  updateSelector: string;
  recipientSelector: string;
  dealId: string | null | undefined;
  dealName: string | null | undefined;
  handleShareClick: () => void;
  hasContents: boolean;
  activeAssetLayout: AssetsLayoutEnum;
  onActiveAssetLayoutChange: (updatedActiveAssetLayoutChange: AssetsLayoutEnum) => void;
  showDealDetails: () => void;
  handleAddAssetClick: () => void;
  handleAddUsersClick?: () => void;
  everyoneChannel: any;
}

export const DealRoomContext = React.createContext<DealRoomContextProps>({
  id: "",
  dealRoom: { sections: [] },
  dealRoomAssets: initialAssetsState,
  activeModule: null,
  entityType: "",
  menuState: {
    primaryAction: 'view'
  },
  onMenuChange: () => {},
  isDealRoomLoading: false,
  updateDealRoomProperty: () => {},
  getNotificationContent() {
    return {
      subject: "",
      message: "",
    }
  },
  getRecipient: () => null,
  fetchRecipientsForPage: () => {},
  updateSelector: "",
  itemSelector: "",
  editSelector: "",
  recipientSelector: "",
  dealId: "",
  dealName: "",
  handleShareClick: () => null,
  hasContents: false,
  activeAssetLayout: AssetsLayoutEnum.LIST,
  onActiveAssetLayoutChange: () => {},
  showDealDetails: () => {},
  handleAddAssetClick: () => {},
  handleAddUsersClick: () => {},
  everyoneChannel: null,
});